import './ErrorMessage.scss';

export default function ErrorMessage({ message, onRetry }) {
    if (!message) return null;

    return (
        <div className="ui-error">
            <p className="ui-error__text">{message}</p>
            {onRetry && (
                <button type="button" className="ui-error__retry" onClick={onRetry}>
                    Повторить
                </button>
            )}
        </div>
    );
}
